import axios from 'axios'

export default {
  namespaced: true,
  state: {
    commonWidgetsShow: null,
    commonWidgetReport: null,
  },
  mutations: {
    setCommonWidgetsShow(state, payload) {
      state.commonWidgetsShow = payload
    },
    setCommonWidgetReport(state, payload) {
      state.commonWidgetReport = payload
    },
  },
  getters: {
  //   configSettings: (state) => {
  //     return state.configSettings
  //   },
    commonWidgetReport: (state) => {
      return state.commonWidgetReport
    },
  },
  actions: {
    onCommonWidgetsShow({ commit, rootState }, { period }) {
      commit('setLoadingAnimationFullPage', true, { root: true })
      let url = rootState.apiDomain + '/api/admin/common/widgets'
      if (period)
      url = url + '?start=' + period[0] + '&end=' + period[1]
      return new Promise((resolve, reject) => {
        axios({
          url:  url,
          method: 'GET',
        })
          .then((resp) => {
            commit('setCommonWidgetsShow', resp.data)
            resolve(resp)
          })
          .catch((err) => {
            reject(err)
          })
          .finally(() => {
            commit('setLoadingAnimationFullPage', false, { root: true })
          })
      })
    },
    onCommonWidgetReport({ commit, rootState }, { period }) {
      commit('setCommonWidgetReport', {})
      let url =
        rootState.apiDomain +
        '/api/admin/common/widgets/reports?start=' +
        period[0] +
        '&end=' +
        period[1]
      return new Promise((resolve, reject) => {
        axios({
          url: url,
          method: 'GET',
        })
          .then((resp) => {
            commit('setCommonWidgetReport', resp.data)
            resolve(resp)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    onCommonWidgetInvoices({ rootState }, { period }) {
      let url =
        rootState.apiDomain +
        '/api/admin/common/widgets/invoices?start=' +
        period[0] +
        '&end=' +
        period[1]
      return new Promise((resolve, reject) => {
        axios({
          url: url,
          method: 'GET',
        })
          .then((resp) => {
            resolve(resp)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
  },
}
